module.exports = __webpack_public_path__ + "static/4-tips-conten2-26bec21fa281b4e1c34f349d205ee18e.png";